(function () {
  if (window.innerWidth > 999) return;

  const THUMB_SIZE = 160;
  const CHECK_INTERVAL = 30;
  const MAX_WATCH_TIME = 700;
  const SCROLL_RESUME_DELAY = 250;

  let isScrolling = false;
  let scrollTimer = null;

  let watchTimer = null;
  let watchStartedAt = 0;

  let lastSeenImage = '';
  let stableCount = 0;

  let lastAppliedImage = '';

  const compositeCanvas = document.createElement('canvas');
  compositeCanvas.width = THUMB_SIZE;
  compositeCanvas.height = THUMB_SIZE;

  const compositeCtx = compositeCanvas.getContext('2d');

  if (!compositeCtx) return;


  function getMainPreviewCanvases() {
    return Array.from(
      document.querySelectorAll('canvas')
    ).filter(function (canvas) {
      return (
        !canvas.closest('.cpb-swiper-thumbnails') &&
        canvas.width > 300 &&
        canvas.height > 300
      );
    });
  }


  function getThumbnailCanvas() {
    return document.querySelector(
      '.cpb-swiper-thumbnails canvas'
    );
  }


  function getFallbackImage() {
    const thumbnailCanvas = getThumbnailCanvas();

    if (!thumbnailCanvas) return null;

    const parent = thumbnailCanvas.parentElement;

    if (!parent) return null;

    let img = parent.querySelector(
      '.cpb-ios-canvas-fallback'
    );

    if (!img) {
      img = document.createElement('img');
      img.className = 'cpb-ios-canvas-fallback';
      img.alt = '';

      parent.style.position = 'relative';
      parent.appendChild(img);
    }

    thumbnailCanvas.style.visibility = 'hidden';

    return img;
  }


  function buildComposite() {
    const canvases = getMainPreviewCanvases();

    if (!canvases.length) {
      return false;
    }

    compositeCtx.clearRect(
      0,
      0,
      THUMB_SIZE,
      THUMB_SIZE
    );

    canvases.forEach(function (canvas) {
      try {
        compositeCtx.drawImage(
          canvas,
          0,
          0,
          canvas.width,
          canvas.height,
          0,
          0,
          THUMB_SIZE,
          THUMB_SIZE
        );
      } catch (error) {
        // Ignore individual layer failures.
      }
    });

    return true;
  }


  function getCurrentPreviewImage() {
    if (!buildComposite()) {
      return '';
    }

    try {
      return compositeCanvas.toDataURL('image/png');
    } catch (error) {
      console.warn(
        'CPB mobile preview snapshot failed:',
        error
      );

      return '';
    }
  }


  function applyImage(src) {
    if (!src || src === 'data:,') return;

    const img = getFallbackImage();

    if (!img) return;

    if (src === lastAppliedImage) {
      return;
    }

    img.src = src;
    lastAppliedImage = src;
  }


  function stopWatching() {
    if (watchTimer) {
      clearInterval(watchTimer);
      watchTimer = null;
    }

    lastSeenImage = '';
    stableCount = 0;
  }


  function checkPreview() {
    if (isScrolling) {
      return;
    }

    const currentImage = getCurrentPreviewImage();

    if (!currentImage) {
      return;
    }

    if (currentImage === lastSeenImage) {
      stableCount += 1;
    } else {
      lastSeenImage = currentImage;
      stableCount = 0;
    }

    /*
     * Apply only after the SAME new frame
     * has been seen twice in a row.
     */
    if (
      stableCount >= 2 &&
      currentImage !== lastAppliedImage
    ) {
      applyImage(currentImage);
      stopWatching();
      return;
    }

    /*
     * Safety fallback:
     * after 700ms, apply the latest valid frame.
     */
    if (
      performance.now() - watchStartedAt >=
      MAX_WATCH_TIME
    ) {
      applyImage(currentImage);
      stopWatching();
    }
  }


  function startWatching() {
    if (isScrolling) return;

    stopWatching();

    watchStartedAt = performance.now();
    lastSeenImage = '';
    stableCount = 0;

    /*
     * Check immediately.
     */
    checkPreview();

    /*
     * Then keep checking briefly.
     */
    watchTimer = setInterval(
      checkPreview,
      CHECK_INTERVAL
    );
  }


  function isInsideCPB(element) {
    return !!(
      element &&
      element.closest &&
      element.closest(
        '.cpb-root, [class*="cpb-"], [id*="cpb"]'
      )
    );
  }


  /*
   * Every keystroke:
   * letters, backspace, delete, paste,
   * mobile keyboard input, etc.
   */
  document.addEventListener(
    'input',
    function (event) {
      if (!isInsideCPB(event.target)) return;

      /*
       * Restart the watch for the latest keystroke.
       */
      startWatching();
    },
    true
  );


  /*
   * Dropdowns / selectors / finished field changes.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (!isInsideCPB(event.target)) return;

      startWatching();
    },
    true
  );


  /*
   * Swatches / buttons.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (!isInsideCPB(event.target)) return;

      setTimeout(
        startWatching,
        20
      );
    },
    true
  );


  /*
   * Freeze the last good replacement image
   * while scrolling.
   */
  function markScrolling() {
    isScrolling = true;

    stopWatching();

    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(function () {
      isScrolling = false;

      startWatching();

    }, SCROLL_RESUME_DELAY);
  }


  window.addEventListener(
    'scroll',
    markScrolling,
    {
      passive: true
    }
  );


  window.addEventListener(
    'touchmove',
    markScrolling,
    {
      passive: true
    }
  );


  /*
   * CPB builds the thumbnail DOM dynamically.
   */
  const observer = new MutationObserver(function (mutations) {
    let foundCanvas = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          node.matches('.cpb-swiper-thumbnails canvas') ||
          node.querySelector('.cpb-swiper-thumbnails canvas')
        ) {
          foundCanvas = true;
        }
      });
    });

    if (foundCanvas) {
      setTimeout(
        startWatching,
        100
      );
    }
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * Initial load.
   */
  window.addEventListener(
    'load',
    function () {
      setTimeout(startWatching, 500);
      setTimeout(startWatching, 1000);
      setTimeout(startWatching, 2000);
    }
  );


  startWatching();

})();